/* unplugin-vue-components disabled */import { render } from "./Save.vue?vue&type=template&id=728f69a2"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"

import "./Save.vue?vue&type=style&index=0&id=728f69a2&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__